import React from "react";
import { _CommissionsDetails, _ProductsTab } from "..";
import { IProvvigioniProduct } from "./CommissionsForm";
import { getGroupedProducts } from "../common/CompanyProducts/helpers";

interface ICommissionsTabProps {
    Products: IProvvigioniProduct[];
    OnCopyValues: (index: number) => any;
    OnChange: (e: string, val?: unknown) => void;
}

export const _CommissionsTab: React.FC<ICommissionsTabProps> = ({ Products, OnCopyValues, OnChange }) => {
    const groupedProducts: IProvvigioniProduct[][] = getGroupedProducts(Products);

    return <_ProductsTab GroupedProducts={groupedProducts} RenderTabContent={index => <_CommissionsDetails Data={groupedProducts[index]} OnCopyValues={OnCopyValues} OnChange={OnChange} />} />;
};



// WEBPACK FOOTER //
// ./src/inar2/components/Commissions/CommissionsTab.tsx